// eslint-disable-next-line
// eslint-disable-next-line no-unused-vars
import "./App.css";
import { FloatButton } from "antd";
import * as React from "react";
import {
	Route,
	BrowserRouter as Router,
	Routes,
	useLocation,
} from "react-router-dom";
import { AdminModalProvider } from "./context/AdminModalContext";
import AuthContext, { AuthProvider } from "./context/AuthContext";
import PrivateRoutes, { AdminRoute } from "./utils/PrivateRoute";
import { usePageTitle } from "./utils/pageTitle";

import "bootstrap/dist/css/bootstrap.min.css";
import ErrorBoundary from "./components/ErrorBoundary";
import Header from "./components/Header";
import InitialPasswordWarningModal from "./components/InitialPasswordWarningModal";
import Dashboard from "./pages/Dashboard";
import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import MyProfile from "./pages/MyProfile";
import Register from "./pages/Register";

function AppRoutes() {
	// Issue #60 PR #92 Codexレビュー指摘: 画面単位のErrorBoundaryにlocation変更時の
	// リセットが無いと、あるルートのrender例外でhasErrorがtrueになった後、
	// 別ルートへ遷移してもフォールバック表示が残り続けてしまう(そのルートだけを
	// 隔離するという本来の意図に反する)。pathnameをkeyに使い、遷移のたびに
	// 各ErrorBoundaryをremountしてhasErrorをリセットする。
	const { pathname } = useLocation();

	// Issue #85: ルートごとにタブタイトルを差し替える（全画面 "Dashboard App" 固定の是正）
	usePageTitle();

	return (
		<AuthProvider>
			<AdminModalProvider>
				<Header />
				<InitialPasswordWarningModal />
				<AppRoutesByUser pathname={pathname} />
				{/* スクロールしたページでだけ現れる（一定量スクロールするまで非表示）。
				    Dashboard は管理者メニューの最下段に同じボタンを持つため除く */}
				{pathname.startsWith("/dashboard") ? null : (
					<FloatButton.BackTop tooltip={<div>Back to top</div>} />
				)}
			</AdminModalProvider>
		</AuthProvider>
	);
}

// Issue #88 Codexレビュー指摘: 別タブで別の利用者がログインすると、このタブでは
// 認証情報だけが差し替わり、表示中の画面が持っている取得済みデータ（一覧・集計）は
// 前の利用者のまま残る（各ページの取得 useEffect は利用者を依存に持たない）。
// 管理者の画面を開いたまま一般利用者へ切り替わると、全社員のデータが残ったまま
// 見えてしまうため、利用者 ID を key にして画面を作り直し、前の利用者のデータを破棄する。
function AppRoutesByUser({ pathname }) {
	const { user } = React.useContext(AuthContext);

	return (
		<Routes key={user?.user_id ?? "anonymous"}>
			<Route element={<PrivateRoutes />}>
				<Route
					element={
						<ErrorBoundary key={pathname}>
							<HomePage />
						</ErrorBoundary>
					}
					path="/"
					exact
				/>
				{/* Issue #89: /dashboard は isAdmin/is_superuser を持つユーザーのみ到達可能にする */}
				<Route element={<AdminRoute />}>
					<Route
						element={
							<ErrorBoundary key={pathname}>
								<Dashboard />
							</ErrorBoundary>
						}
						path="/dashboard"
						exact
					/>
				</Route>
				<Route
					element={
						<ErrorBoundary key={pathname}>
							<MyProfile />
						</ErrorBoundary>
					}
					path="/profile"
					exact
				/>
			</Route>
			<Route
				element={
					<ErrorBoundary key={pathname}>
						<Login />
					</ErrorBoundary>
				}
				path="/login/"
			></Route>
			{/* Issue #89: /register/ は認証不要ルートとして孤立していたため閉鎖。
					    Register.js本体・importは復活容易のため残置(ルート復活時はここに
					    <Route path="/register/" element={<ErrorBoundary key={pathname}><Register /></ErrorBoundary>} /> を戻す) */}
		</Routes>
	);
}

function App() {
	return (
		<div className="App">
			<Router>
				{/* Issue #60: AuthProvider自体の例外も捕捉するため外側に1枚配置する */}
				<ErrorBoundary>
					<AppRoutes />
				</ErrorBoundary>
			</Router>
		</div>
	);
}

export default App;
